import getters from "./getters";
import actions from "./actions";
import location from "./location";
import verification from "./verification";
import * as types from "./../action-types";
import { set, get, extend, cloneDeep } from "lodash";
import Vue from "vue";
import { isString } from "lodash/lang";

const vClone = (object) => Vue.util.extend({}, object);

const initialState = () =>
  cloneDeep({
    currentDevice: {},
    pii_authorized: false,
    pii_flag_on: false,
    dccs_flag_on: false,
    screensharing_enabled: false,
    customer: {},
    locations: {},
  });

const normalizeClientDevicesMetadata = (customer) => {
  let clientDevices = get(customer, "client_devices", []);
  clientDevices.forEach((device) => {
    let metadata = get(device, "metadata", {});
    if (metadata.hasOwnProperty("ios_version"))
      metadata.os_version = metadata.ios_version;
  });

  if (isString(customer.phone_number)) {
    customer.phone_number = customer.phone_number.replace(/^\+/, "");
  }
  return customer;
};

const mutations = {
  [types.GLOBAL_SEARCH.SUCCESS](state, { model, result }) {
    if (model === "Device") state.currentDevice = result;
    else if (model === "Customer") {
      state.pii_authorized = get(result, "authorized", false);
      state.account_verified = get(result, "verified", false);
      state.locations = get(result, "customer.locations", []);
      // TODO: create a directive to handle FF in ND
      let flags = result.feature_flags || {};
      let bool = (v) => (typeof v === "boolean" ? v : v === "ON");
      state.pii_flag_on = bool(flags.pii);
      state.dccs_flag_on = bool(flags["dccs"]);
      state.arid_enabled = bool(flags["arid_enabled"]);
      state.customer = normalizeClientDevicesMetadata(get(result, "customer"));
      state.oow_amount_of_days_for_bypass_hard_block = parseInt(
        flags["oow_amount_of_days_for_bypass_hard_block"]
      );
    }
  },
  [types.UPDATE_CUSTOMER_PROFILE](state, payload) {
    if (payload.data.profile) {
      extend(state.customer.profile, payload.data.profile);
      delete payload.data.profile;
    }

    if (payload.data) {
      let customer = extend({}, state.customer, payload.data);
      state.customer = normalizeClientDevicesMetadata(customer);
    }
  },
  [types.GLOBAL_SEARCH.ERROR]() {
    console.info("types.GLOBAL_SEARCH.ERROR", types.GLOBAL_SEARCH.ERROR);
  },

  [types.SCREEN_SHARING](state, { enabled }) {
    state.screensharing_enabled = enabled;
  },
  [types.SET_VERIFICATION_CHANNELS](state, data) {
    state.verificationChannels = get(data, "channels", []);
  },
  [types.IS_FIRST_VERIFICATION_ATTEMPT](state, data) {
    state.isFirstVerificationAttempt = data;
  },
  setCustomerProfile(state, customer) {
    let profile = vClone(customer);
    state.customer = normalizeClientDevicesMetadata(customer);
    // TODO: temporal fix, the customer set by device page load must be the same as the one set by account page
    if (customer.doorbot_user_id) {
      customer.id = customer.doorbot_user_id;
    }
    state.customer.profile = profile;
  },
  resetState(state) {
    Object.assign(state, initialState());
  },
  setSecurityStatus(state, value) {
    state.customer.security_status = value;
  },
};

export default {
  state: initialState(),
  mutations,
  getters,
  actions,
  namespaced: true,
  modules: { location, verification },
};
